import React from "react"

import Icons from "./icons"

import * as S from "./styled"

const Button = ({
  type,
  color,
  variant,
  size,
  children,
  className,
  hasIcon,
  hasIconAfter,
  onClick,
  disabled,
}) => {
  const Icon = hasIcon ? Icons[hasIcon] : false
  const IconAfter = hasIconAfter ? Icons[hasIconAfter] : false

  return (
    <S.Button
      disabled={disabled}
      type={type || "button"}
      className={className}
      variant={variant}
      color={color}
      size={size}
      onClick={onClick}
    >
      {Icon ? <Icon /> : ""} {children}{" "}
      {IconAfter ? <IconAfter className="icon-after" /> : ""}
    </S.Button>
  )
}

export default Button
